import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { useThreadsAuth } from '../context/ThreadsAuthContext';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  background: #111;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(254, 136, 241, 0.15);
  border-top-color: #fe88f1;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const Message = styled.p`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.5);
`;

const ErrorBox = styled.div`
  max-width: 400px;
  text-align: center;
  padding: 32px;

  h2 { color: #fff; margin-bottom: 12px; }
  p  { color: rgba(255,255,255,0.5); margin-bottom: 24px; }
`;

const BackLink = styled.button`
  background: #fe88f1;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 10px 24px;
  font-weight: 700;
  cursor: pointer;
`;

const AuthCallback = () => {
    const { login } = useThreadsAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const userEncoded = params.get('user');
        const error = params.get('error');

        if (error || !token || !userEncoded) {
            // Stay on this page in error state — handled below via missing state
            return;
        }

        try {
            const user = JSON.parse(decodeURIComponent(userEncoded));
            login(token, user);

            // Return to the page the user was on before login, or default to /blogs
            const returnTo = sessionStorage.getItem('threads_return_to') || '/blogs';
            sessionStorage.removeItem('threads_return_to');
            navigate(returnTo, { replace: true });
        } catch {
            // parse error — fall through to error UI
        }
    }, [login, navigate]);

    const params = new URLSearchParams(window.location.search);
    const hasError = params.get('error') || (!params.get('token') && !params.get('user'));

    if (hasError) {
        return (
            <Wrapper>
                <ErrorBox>
                    <h2>Login Failed</h2>
                    <p>Something went wrong during Threads authorization. Please try again.</p>
                    <BackLink onClick={() => navigate('/blogs')}>Back to Blog</BackLink>
                </ErrorBox>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <Spinner />
            <Message>Logging you in with Threads…</Message>
        </Wrapper>
    );
};

export default AuthCallback;
